import React from 'react';
import './style.scss';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/onions_hero.jpg';
import imgHeroMobile from './i/mobile/onions_hero.jpg';
import arrow from '../../../../assets/images/hero-arrow.png';
import { TranslatableText } from '../../../../providers/LanguageProvider';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/carousel_onions_1.jpg';
import slide2 from './i/carousel_onions_2.jpg';
import slide3 from './i/carousel_onions_3.jpg';
import slide4 from './i/carousel_onions_4.jpg';
import slide5 from './i/carousel_onions_5.jpg';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Onions = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food-pages onions">

                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="onions" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="oignons" />
                    }
                </div>

                <div className="copy-block">
                    <h1><span><span className="line"></span><TranslatableText dictionary={{ "en": "Our", "fr": "Nos"}} ></TranslatableText><span className="line"></span></span><TranslatableText dictionary={{ "en": "Onions", "fr": "Oignons"}} ></TranslatableText></h1>
                
                    {props.lang === 'en' && <p>Our onion growers produce some of the highest quality and most flavourful onions on the market. For our partners at Gills Onions, every onion is grown with the next in mind— 100% of daily onion waste is converted into ultra-clean energy.</p>}
                    {props.lang === 'fr' && <p>Les oignons de nos agriculteurs sont parmi les meilleurs sur le marché, tant sur le plan de la saveur que sur celui de la qualité. Provenant de nos partenaires de Gills Onions, chaque oignon est cultivé avec la prochaine récolte en tête. Et la totalité des déchets issus de la production d’oignons est transformée en énergie propre.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            <div className="where-block">
                            
                {props.lang !== 'fr' ?
                    <>
                        <h2>What's our&nbsp;  
                            <span>onion story?</span>
                        </h2>
                    </>
                    :
                    <>
                        <h2>D’où viennent nos&nbsp;  
                            <span>onions?</span>
                        </h2>
                    </>
                }
            </div>

            <SliderWrap {...props}>
                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>NOTHING BUT GOOD SEEDS</h3>
                                        <p>The yellow onions used in our onion rings are grown from carefully selected seeds.</p>
                                    </>
                                :
                                    <>
                                        <h3>QUE DE BONS SEMIS</h3>
                                        <p>Les oignons jaunes utilisés pour préparer nos rondelles proviennent de semis soigneusement sélectionnés.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>GROWN TO PERFECTION</h3>
                                        <p>It takes around 200 days for the onion plants to reach maturity.</p>
                                    </>
                                :
                                    <>
                                        <h3>CULTIVÉS À LA PERFECTION</h3>
                                        <p>Il faut environ 200 jours pour qu’un plant  arrive à maturité.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>SUN-CURED</h3>
                                        <p>The onions are dug up and left to cure in the warm sunshine.</p>
                                    </>
                                :
                                    <>
                                        <h3>SOUS LE SOLEIL</h3>
                                        <p>Les oignons sont déterrés et laissés sur le sol sous un soleil ardent.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>PACKED WITH FLAVOUR</h3>
                                        <p>When their outer skin is dry, the fresh onions are collected, sorted and packed for A&W.</p>
                                    </>
                                :
                                    <>
                                        <h3>REMPLIS DE SAVEUR</h3>
                                        <p>Quand la pelure extérieure est sèche, les oignons frais sont ramassés pour être triés et emballés pour A&W.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="5" className="item">
                    <div className="itemcol">
                        <img src={slide5} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>BREADED BY HAND</h3>
                                        <p>Onion rings are battered and breaded by hand, resulting in crispy golden rings.</p>
                                    </>
                                :
                                    <>
                                        <h3>PRÉPARÉES À LA MAIN</h3>
                                        <p>Les oignons sont tranchés et plongés à la main dans une panure maison. Le résultat final : des rondelles dorées et croustillantes.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>

            </SliderWrap>

            <IngredientsSlider currentPage="onions" {...props} />
            <MobileOrderBanner {...props} />

        </>

    )
}
export default Onions;